import React from 'react';
import { CreateUser } from '../..';

export const CreateAdmin = (props) => (
  <CreateUser title='Add New Admin' headText='Provide information for the new Admin' managedRole='Admin' {...props} />
);
